import type { TagProduct } from '~~/types/integrations/tagManager/TagProduct';
import type { PurchaseOrderInformations, PurchaseAttributes, PurchaseCategory, PurchaseEventInfo, PurchaseEcommerceType } from '~~/types/integrations/tagManager/PurchaseTypes';
import {
  EVENT_PURCHASE,
  EVENT_PURCHASE_DEFAULT_EVENT_TYPE,
  PRIMARY_CATEGORY,
} from '~~/constants/googleTagManager';

export const buildPurchaseTags = ({
  tagProducts,
  orderInformation,
  attributes,
}: {
  tagProducts: TagProduct[];
  orderInformation: PurchaseOrderInformations;
  attributes?: PurchaseAttributes;
}) => ({
  event: EVENT_PURCHASE,
  eventInfo: {
    detail: EVENT_PURCHASE,
  } as PurchaseEventInfo,
  category: {
    event_type: EVENT_PURCHASE_DEFAULT_EVENT_TYPE,
    primary_category: PRIMARY_CATEGORY,
  } as PurchaseCategory,
  attributes,
  ecommerce: {
    items: tagProducts,
    ...orderInformation,
  } as PurchaseEcommerceType,
});
